import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu'
import LinkWallet from '../../LinkWallet';
import { StyledNav, StyledLink } from './Nav.styled';
import { NavItems } from '../../../constants/NavItems';
import ChatImage from "../../../assets/images/chat.png"

interface Props {
    setChatOpen: (status: boolean) => void
}

const Nav = (props: Props) => {
    const location = useLocation();

    return (
        <StyledNav className='desktop'>
            {
                NavItems.map((item, index) => (
                    <StyledLink to={item.link} key={index} className={`${location.pathname == item.link ? "active" : ""}`}>{item.title}</StyledLink>
                ))
            }
            <LinkWallet />
            <img src={ChatImage} alt="Chat Image" onClick={() => props.setChatOpen(true)} style={{cursor: 'pointer'}} />
        </StyledNav>
    );
}

export default Nav;
